import React from 'react';
import Badges from 'modules/common/components/Badge';
import Pagination from 'partial/components/Pagination';
import Table from 'partial/components/Table';
import { useReportsContext } from 'partial/wrappers/ReportsContext';

const format = [
  { label: 'ORGANIZATION NAME', key: 'organization_name' },
  { label: 'MASK NAME', key: 'name' },
  { label: 'DATE APPROVED', key: 'approved_at' },
  { label: 'EXPIRY DATE', key: 'expired_at' },
  {
    id: 'status',
    key: ({ status }) => (
      <Badges status={status} containerClassName="!text-xs !px-4 w-[120px]" />
    ),
    labelClassName: 'px-[24px] md:!px-11 whitespace-nowrap flex justify-end',
    contentClassName: 'px-[24px] md:!px-11 whitespace-nowrap flex justify-end',
    label: 'STATUS',
  },
];

export default function MaskNames() {
  const { isLoading, list, meta, setPage } = useReportsContext();

  return (
    <div className="flex flex-col gap-10 min-h-[65vh]">
      <Table isLoading={isLoading} data={list} format={format} />
      {!isLoading && <Pagination value={meta} onChange={setPage} />}
    </div>
  );
}
